// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { HealthcareService, Practitioner, Reference, Schedule, Slot } from '@medplum/fhirtypes';
import type { ProposedAppointment } from '@polarissleep/scheduling-next';

export interface ProviderAppointmentCandidate {
  appointment: ProposedAppointment;
  key: string;
  providerId: string;
  providerName: string;
  providerTimezone: string;
  serviceId: string;
  serviceName: string;
  serviceCode: string;
}

export const V2_DAY_CODES = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
export type V2DayCode = (typeof V2_DAY_CODES)[number];

export type OverrideSlotStatus = 'free' | 'busy-unavailable';

export interface WeeklyAvailabilityWindow {
  dayOfWeek: V2DayCode;
  startTime: string;
  endTime: string;
}

export interface AvailabilityOverrideDraft {
  id?: string;
  healthcareServiceId: string;
  date: string;
  startTime: string;
  endTime: string;
  reason?: string;
  status: OverrideSlotStatus;
  createdBy?: Reference;
}

export interface AppointmentConflict {
  id: string;
  start: string;
  end?: string;
  status: string;
  patientDisplay?: string;
}

export interface V2AvailabilityDraft {
  timezone: string;
  bufferAfterMinutes?: number;
  healthcareServiceId: string;
  healthcareServiceIds?: string[];
  weeklyAvailability: WeeklyAvailabilityWindow[];
  overrides: AvailabilityOverrideDraft[];
  conflictAcknowledged?: boolean;
  createdBy?: Reference;
}

export interface V2AvailabilityResources {
  practitioner: Practitioner;
  schedule?: Schedule;
  healthcareServices: HealthcareService[];
  overrideSlots: Slot[];
}
